/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ----------------------------------------------------------------------------------------- */
'use strict';

const ral = require("./lib/common/ral");

module.exports = require('./lib/browser/main');
module.exports.default = ral.default;